import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery'
import Isotope from 'isotope-layout';
import packery from 'isotope-packery';


// get hash value for filter, if no hash then set filter "all"
function getHashFilter() {
    var hash = location.hash;

    // if no hash exists, select all
    if (!hash) {
        var hashFilter = "*";
        var matches;
        $('.IsotopeFilter button[data-filter="*"]').addClass('active');

    // if hash from arbeitsgebiete exists, filter for this hash
    } else {
        var matches = location.hash.match(/filter=([^&]+)/i);
        var hashFilter = "." + matches[1];
        $('.IsotopeFilter button[data-filter=' + matches[1] + ']').addClass('active');
    }
    
    return hashFilter;
}


// Container for isotope grid
class ItemGrid extends Component {
    
    constructor(props) {
        super(props);
        this.state = { isotope: null };
    }

    render() {
        return (
            <div className="grid">
                {this.props.children}
            </div>

            
        )
    }

    // set up isotope
    componentDidMount() {
    
        const node = ReactDOM.findDOMNode(this);

            if (!this.state.isotope) {
            this.setState({                
                isotope: new Isotope('.grid', {
                    // options
                    layoutMode: 'packery',
                    resizable: false,
                    filter: getHashFilter(),
                    packery: {
                        columnWidth: '.grid-sizer',
                        gutter: 10
                    },
                    itemSelector: '.grid-item',
                    percentPosition: true
                    
                })
            })

            $('.grid').fadeIn('slow');
            // $('.IsotopeFilter button:first-child').addClass('active');
                getHashFilter();
      


            $('.IsotopeFilter button').not(':first-child').on('click', function () {
                // get filter value from option value
                $('.IsotopeFilter button').removeClass('active');
                $(this).toggleClass('active');
                var filterValue = $(this).attr("data-filter");
                $('.grid-item, .grid-item--width2').fadeIn();
                // // use filterFn if matches value

                isotope: new Isotope('.grid', {
                    filter: '.'+filterValue+'',
                    layoutMode: 'masonry',
                    percentPosition: false,
                    resizable: true,
                    masonry: {
                        columnWidth: '.grid-item',
                        gutter: 5
                    }
                });
                return false;
                

            });

            $('.IsotopeFilter button:first-child').on('click', function () {
                $('.IsotopeFilter button').removeClass('active');
                $(this).toggleClass('active');
                $('.grid-item, .grid-item--width2').fadeIn();
                
                isotope: new Isotope('.grid', {
                    filter: '*',
                    layoutMode: 'masonry',
                    percentPosition: false,
                    resizable: true,
                    masonry: {
                        columnWidth: '.grid-item',
                        gutter: 5
                    }
                });
                return false;

            });
                           
    
        } else {
            this.state.isotope.reloadItems();
            this.state.isotope.layout();
         
        }
    }

    // update isotope layout
    componentDidUpdate() {
        if (this.state.isotope) {
            this.state.isotope.reloadItems();
            $('window').resize();
            this.state.isotope.layout();
           

        }


    }
}

export default ItemGrid;


// WEBPACK FOOTER //
// ./src/components/isotopify.js